module.exports = __webpack_public_path__ + "media/img/corporate/events3-3fef52c37c7cf3461304e018f8f63557.png";